module.exports = __webpack_public_path__ + "static/img/图片7.b7347c32.png";